<template>
  <v-container fluid>
    <v-skeleton-loader :loading="loading" :types="skeleton" type="article" class="mb-6">
      <v-card class="elevation-1 mb-6 rounded-lg">
        <v-card-title class="pa-7"> Detail administrátora </v-card-title>
        <v-card-text class="pa-7">
          <v-row>
            <v-col cols="6">
              <v-row>
                <v-col cols="12" class="py-0">
                  <div class="request-label">E-mail</div>
                  <div class="request-value mt-2">
                    {{ user.email }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pl-7 pr-7 pb-7">
          <v-spacer></v-spacer>
          <template>
            <v-btn
              type="submit"
              height="40px"
              min-width="130px"
              color="primary"
              depressed
              :to="{ name: 'administrators.edit', params: { id: user.id } }"
            >
              Editovat
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-skeleton-loader>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AdministratorDetail',
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      user: {},
      loading: false,
      saving: false,
    }
  },
  created() {
    this.loadUser()
  },
  methods: {
    ...mapActions({
      getUser: 'user/getUser',
    }),
    loadUser() {
      this.loading = true
      this.getUser(this.$route.params.id)
        .then((response) => {
          this.user = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
